module.exports = __webpack_public_path__ + "static/media/web_development.40ce6b91.svg";